<div class="flex space-x-2 items-center ml-[1px]">
    <mat-checkbox
        #inputElement
        aria-label="Select Emission Designators"
        color="primary"
        [formControl]="formControl"
    ></mat-checkbox>
    <div
        class="flex flex-row flex-wrap"
        [class]="{ 'mb-0.5': emissionDesignators().length !== 0 }"
    >
        @if (emissionDesignators().length > 0) {
            @for (
                emissionDesignator of emissionDesignators();
                track emissionDesignator;
                let index = $index
            ) {
                <div
                    class="h-4 !align-text-top uppercase text-xs text-primary-700 font-medium"
                >
                    <button
                        class="!m-0"
                        type="button"
                        [disabled]="isReadOnly"
                        (click)="onClick()"
                    >
                        {{ getTitle(emissionDesignator) }}
                    </button>
                    @if (index < emissionDesignators().length - 1) {
                        <span>, </span>
                    }
                </div>
            }
        } @else {
            <button
                class="!m-0 text-sm text-primary-700 font-medium"
                type="button"
                (click)="onClick()"
            >
                Select
            </button>
        }
    </div>
</div>
